var map = {
	"./Base/serverStyle": 125,
	"./Clutch/serverStyle": 1858,
	"./NewUi/serverStyle": 1859,
	"./OldUi/serverStyle": 1860,
	"./SpireonNew/serverStyle": 1861,
	"./SpireonOld/serverStyle": 1862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;